import * as yup from "yup";
import decimalStr from "utils/schemas/decimalStr";
import { makeFormatDecimal } from "utils/formatting";

const DIMENSIONS = ["height", "width", "depth"] as const;

type Dimension = typeof DIMENSIONS[number];

export type Dimensions = Record<Dimension, Decimal>;

const dimensionSchema = decimalStr({
  numberFormatter: makeFormatDecimal({
    style: "unit",
    unit: "inch",
    unitDisplay: "narrow",
  }),
})
  .min(0)
  .max(1000, { isExclusive: true })
  .nullable()
  .default(null);

export const height = dimensionSchema.label("Height");

export const width = dimensionSchema.label("Width");

export const depth = dimensionSchema.label("Depth");

// eslint-disable-next-line no-template-curly-in-string
const REQUIRED_MSG = "All dimensions must be provided; missing ${label}";

const dimensions = yup
  .object()
  .shape({ width, height, depth })
  .when([".width", ".height", ".depth"], {
    is: (
      w: Decimal | null | undefined,
      h: Decimal | null | undefined,
      d: Decimal | null | undefined,
    ) => w || h || d,
    then: (s) =>
      s
        .shape({
          width: width.required(REQUIRED_MSG),
          height: height.required(REQUIRED_MSG),
          depth: depth.required(REQUIRED_MSG),
        })
        .required(),
    otherwise: (s) =>
      s
        .transform((value: Partial<Dimensions> | null | undefined) => {
          if (!value) return value;

          if (!value.height && !value.width && !value.depth) return null;

          return value;
        })
        .nullable(),
  }) as yup.ObjectSchema<Dimensions>;

export default dimensions;
